/**
 * @fileoverview CSS module for the Question component.
 * Provides styling for the Question component, which displays a question and its options.
 *
 * @example
 * // Usage in a component:
 * import styles from './Question.module.css'
 *
 * function Question() {
 *   return <div className={styles.container}>Question content</div>
 * }
 */

.transition_enter {
    opacity: 0;
    transform: translateX(24px);
}

.transition_enter_active {
    opacity: 1;
    transform: translateX(0px);
    transition: all 300ms;
}

.transition_exit {
    opacity: 1;
    transform: translateX(0px);
}

.transition_exit_active {
    opacity: 0;
    transform: translateX(-24px);
    transition: all 300ms;
}

@supports (font-variation-settings: normal) {
    .container {
        font-family: 'Inter', 'system-ui';
    }
}

.container {
    font-weight: 300;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.011em;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: relative;
    color: var(--neutural900);
    border-radius: var(--radius-xl);
    box-shadow: 0px 0px 1px rgba(49, 46, 129, 0.32), 0px 6px 8px -2px rgba(49, 46, 129, 0.02),
        0px 16px 64px -8px rgba(49, 46, 129, 0.18);
}

.content p {
    padding: 0;
    margin: 0;
}

.content {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 480px;
    margin: 0 auto;
    width: 100vw;
    background-color: var(--neutural000);
    padding: 24px;
    box-sizing: border-box;
    border-radius: var(--radius-xl);
}

.logo {
    margin: 20px auto 40px;
}

@media only screen and (min-width: 768px) {
    .content {
        min-width: auto;
        width: 46.5rem;
        min-height: 400px;
        padding: 48px;
    }
}
